module.exports = __webpack_public_path__ + "img/FAV_0097.fbef8138.jpg";